import React, { useEffect, useState } from "react";
import auth from "./auth";
import Router from "./Router";
import { GetUser } from "./actions/APIcalls";

const Authenticator = (props) => {
    const [loading, setIsloading] = useState(false);
    useEffect(async () => {
        const response = await GetUser();
        if (response && response.data && response.data.success) {
            auth.setLogin(response.data.user, response.headers.endedpackage, JSON.parse(response.headers.disconnected));
            localStorage.removeItem('progressBar')
            localStorage.removeItem('hideSurvey')
            if (response && response.data && response.data.user && response.data.user.progressBar && (typeof response.data.user.progressBar.GetReward != 'undefined' && !response.data.user.progressBar.GetReward)) {
                localStorage.setItem('progressBar', true)
            }

            // add phoneNumber to clarity
            if (response && response.data && response.data.user && response.data.user.phone) {
                if (window.clarity && typeof window.clarity === "function") {
                    window.clarity("set", "SellerPhone", response.data.user.phone);
                }
            }

            setIsloading(true);
        } else {
            auth.setLogout({});
            setIsloading(true);
        }
    }, []);
    if (loading) {
        return <Router {...props}></Router>
    } else {
        return <div></div>
    }
}

export default Authenticator;